2///<reference path="../common.js" />
import { closeModal, showToast } from "../common";
import { DemandStatus } from "../enums/DemandStatus";
import { AssignmentDemand } from "../models/AssignmentDemand";
import { AssignmentsHistory } from "../models/AssignmentsHistory";
import { Project } from "../models/Project";
import { PageContext } from "../page-context";
import { BaseView } from "./base-view";

export class DemandCopyView extends BaseView {

    static title = "Demand Copy";
    static icon = "bi bi-front";
    data: any;
    copied: boolean;
    projects!: Project[];
    resolve: ((value: unknown) => void) | undefined;

    /**
   * constructor
   * @param {PageContext} context - The context of the page.
   * @param {string} [container=".main"] - The container to render the view in.
   */
    constructor(context: PageContext, container = ".main") {
        super(context, container);

        this.data = this.context.projectAssignments;
        this.copied = false;
    }

    connectedCallback(): this {
        super.connectedCallback();

        let versionCheck = this.checkVersionAsync();
        Promise.all([versionCheck]).then(() => {
            let dataLoad = [
                this.context.store.getProjects()
            ]

            Promise.all(dataLoad).then((values) => {
                this.projects = values[0];

                this.onDataLoaded();
            });
        });
        return this;
    }

    onDataLoaded() {
        $(".modal-title").html(`<i class="${DemandCopyView.icon}"></i> Demand Copy`);

        this.innerHTML = `
        <form>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-6">
                        <label for="startDate">Start date</label>
                        <input type="date" class="form-control user-input" id="startDate" value="${this.getNextYearStartDate()}" disabled>
                    </div>
                    <div class="col-6">
                        <label for="endDate">End date</label>
                        <input type="date" class="form-control user-input" id="endDate" value="${this.getNextYearLastDay()}">
                        <div class="invalid-feedback endDate-error" style="line-height: 1; margin-top: 5px;"></div>                    
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label for="targetProject">Target Project*</label>
                                    <input type="text" class="form-control user-input" id="targetProject" list="projects"}">
                                    <div class="invalid-feedback project-error"></div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6 d-flex justify-content-center">
                        <button type="button" class="btn btn-primary btn-save me-1 mb-1">Save</button>
                    </div>
                    <div class="col-6 d-flex justify-content-center">
                        <button type="button" onclick="closeModal()" class="btn btn-secondary btn-cance l me-1 mb-1">Cancel</button>
                    </div>
                </div>
            </div>
        </form>
        
        <datalist id="projects">
            ${this.projects
                .map((project) => {
                    return `<option value="${project.id}">${project.projectName}</option>`;
                })
                .join("")}
        </datalist>
        `;

        const elem = $(this);

        elem.find("#endDate").change((e) => this.checkEndDateValidity());
        elem.find("#targetProject").change((e) => this.handleInputChange("project with id ", "#targetProject"));

        elem.find(".btn-save").click(async (e) => {
            if (!(await this.validateForm())) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }

            if (!window.confirm(`Are you sure you want to save? \n\nThis will copy ${this.data.assignments.length} assignments from ${this.data.project.id} to ${elem.find("#targetProject").val()}.`)) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }

            this.showLoading();

            this.copied = true;
            const days = this.calculateWorkingDays();

            let assignments: AssignmentDemand[] = [];
            let assignmentHistories: AssignmentsHistory[] = [];
            this.data.assignments.forEach((assignment: AssignmentDemand) => {

                const totalPlanned = assignment.pdTotalPlanned;
                const assignmentDays = this.calculateWorkingDays(assignment.startDate, assignment.endDate);
                if (!days || days < 0) return;

                let assignmentPlannedPercent = (Math.round((totalPlanned / assignmentDays) * 100));
                let newProjectDays = Math.round((days * assignmentPlannedPercent) / 100);
                var projectId: string = elem.find("#targetProject").val() as string;
                if (!projectId) {
                    throw new Error("Project ID is required");
                }
                let id = self.crypto.randomUUID();
                var copiedDemand = new AssignmentDemand(assignment);
                copiedDemand.id = id;
                copiedDemand.comments = [];
                copiedDemand.manuallyPlanned = false;
                copiedDemand.status = DemandStatus.Open;
                copiedDemand.plannedWeeks = {};
                copiedDemand.originatingProjectId = this.data.project.id;
                copiedDemand.projectId = projectId;
                copiedDemand.startDate = new Date(this.getHTML5DateValue(elem.find("#startDate").val() as string || null));
                copiedDemand.endDate = new Date(this.getHTML5DateValue(elem.find("#endDate").val() as string || null));
                copiedDemand.pdTotalPlanned = newProjectDays;
                copiedDemand.dueDate = new Date(this.getHTML5DateValue(elem.find("#endDate").val() as string || null));
                assignments.push(copiedDemand);


                let historyObj = {
                    id: id,
                    history: [{
                        date: new Date(),
                        user: this.context.user.userId,
                        changes: {
                            "Demand Copied": {
                                new: elem.find("#targetProject").val(),
                                old: assignment.projectId,
                            }
                        },
                    }],
                };

                assignmentHistories.push(historyObj);
            });

            await Promise.all([
                ...assignments.map(async (assignment) => {
                    await this.context.store.updateAssignment(assignment);
                }),
                ...assignmentHistories.map(async (assignmentHistory) => {
                    await this.context.store.updateAssignmentHistory(assignmentHistory);
                })
            ]);

            this.hideLoading();

            showToast(`Copied ${assignments.length} assignments from ${this.data.project.id} to ${elem.find("#targetProject").val()}.`, "success");

            if (this.resolve)
                this.resolve(assignments);

            setTimeout(() => closeModal());
        });
    }

    calculateWorkingDays(startDate: Date | null = null, endDate: Date | null = null): number {
        const elem = $(this);
        if (startDate == null || endDate == null) {
            startDate = new Date(this.getHTML5DateValue(elem.find("#startDate").val() as string || null));
            endDate = new Date(this.getHTML5DateValue(elem.find("#endDate").val() as string || null));
        }

        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return -1;

        const workingDays = [];
        let currentDate = startDate;
        while (currentDate <= endDate) {
            if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
                workingDays.push(currentDate);
            }
            currentDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);
        }
        return workingDays.length;
    }

    async validateForm() {
        let elem = $(this);
        let form = elem.find("form")[0];
        form.classList.add("was-validated");

        let result = true;
        result = this.handleInputChange("project with id ", "#targetProject") && result;

        return result;
    }

    checkEndDateValidity() {
        const elem = $(this);
        const startDateValue = elem.find("#startDate").val() as string | null;
        const startDate = startDateValue ? new Date(startDateValue) : null;
        const endDateValue = elem.find("#endDate").val() as string | null;
        const endDate = endDateValue ? new Date(endDateValue) : null;

        if (!startDate || !endDate) {
            (elem.find("#endDate")[0] as HTMLInputElement).setCustomValidity("Please enter a valid date.");
            $(".endDate-error").text("Please enter a valid date.");
            return false;
        } else {

            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(0, 0, 0, 0);
            if (endDate >= startDate) {
                (elem.find("#endDate")[0] as HTMLInputElement).setCustomValidity("");
                $(".endDate-error").text("");
                $(".invalid-feedback.endDate-error").removeClass("invalid-feedback-show");
                $("#endDate").removeClass("invalid-border-show");
                return true;
            } else {
                const error = "Invalid date. End date must be greater than start date.";
                (elem.find("#endDate")[0] as HTMLInputElement).setCustomValidity(error);
                $(".endDate-error").text(error);
                $(".invalid-feedback.endDate-error").addClass("invalid-feedback-show");
                $("#endDate").addClass("invalid-border-show");
                return false;
            }
        }
    }

    handleInputChange(response: string, id: string) {
        const input = $(id);
        const inputValue = input.val() && (input.val() as string).trim() || "";
        const dataList = input.attr("list") || "";
        let validationError = "";
        var datalistItem = document.getElementById(dataList);

        if (
            inputValue != undefined &&
            !(datalistItem && datalistItem.querySelector(`option[value="${inputValue}"]`))
        ) {
            validationError = "Invalid input. Please choose from the list.";
        }

        (input[0] as HTMLInputElement).setCustomValidity(validationError);
        input.next().text(validationError);

        return validationError === "" ? true : false;
    }

    getNextYearStartDate() {
        let nextYear = new Date().getFullYear();
        //go into the next year if we are in the second half of the year, otherwise the copy function is not ussable at the begining of the year (Januarry)
        if (new Date().getMonth() > 6)
            nextYear += 1;
        const nextYearStartDate = new Date(nextYear, 0, 1); // January is month 0
        nextYearStartDate.setHours(nextYearStartDate.getHours() + 5); // Add 5 hours
        return nextYearStartDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    }

    getNextYearLastDay() {
        let currentYear = new Date().getFullYear();
        //go into the next year if we are in the second half of the year, otherwise the copy function is not ussable at the begining of the year (Januarry)
        if (new Date().getMonth() > 6)
            currentYear += 1;
        const lastDayOfCurrentYear = new Date(currentYear, 11, 31); // December is month 11
        lastDayOfCurrentYear.setHours(lastDayOfCurrentYear.getHours() + 5); // Add 5 hour
        return lastDayOfCurrentYear.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    }

    async getResult() {
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
        });
    }
}

